import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-7 px-4 sm:px-6 bg-brand-beige" data-id="element-75">
      <div className="bg-white border-2 border-brand-gold p-5 rounded-lg text-center shadow-md" data-id="element-76">
        <p className="text-xs font-bold text-brand-orange uppercase tracking-widest mb-3" data-id="element-77">
          YOUR INVESTMENT IS 100% PROTECTED
        </p>
        <div className="w-14 h-14 mx-auto bg-brand-gold/15 rounded-full flex items-center justify-center mb-3 border border-brand-gold/40" data-id="element-78">
          <ShieldCheck className="w-7 h-7 text-brand-gold" data-id="element-79" />
        </div>
        <h3 className="text-xl font-heading font-black text-brand-green mb-2 uppercase leading-tight" data-id="element-80">
          🛡️ 7-Day Total Guarantee
        </h3>
        <p className="text-sm font-bold text-brand-ink mb-3 uppercase tracking-wide" data-id="element-81">
          Your money is 100% protected.
        </p>
        <p className="text-sm text-brand-ink/80 leading-snug" data-id="element-82">
          You have 7 full days to explore the entire system, review the
          protocols, implement the training programs, and evaluate the results
          with your dogs and clients. If you're not completely satisfied — for
          any reason, at any time within those 7 days — we'll refund 100% of
          your money. Zero risk for you. No questions. No hoops to jump through.
          No fine print.
        </p>
      </div>
    </section>;
}